var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-trans-details" },
    [
      _c(
        "div",
        { staticClass: "filter-right-container" },
        [
          _c("div", { staticClass: "filter-container-tag" }, [
            _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
          ]),
          _c(
            "el-popover",
            { attrs: { placement: "bottom", trigger: "click" } },
            [
              _c("div", { staticClass: "filter-section-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.create_time,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "create_time", $$v)
                            },
                            expression: "search.create_time",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "filter-item",
                        class: { "border-red": _vm.isShowBorderRed },
                      },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("merchantAccount.complete_time")) +
                              " "
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.return_time,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "return_time", $$v)
                            },
                            expression: "search.return_time",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { filterable: "", clearable: "" },
                            model: {
                              value: _vm.search.channel_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "channel_code", $$v)
                              },
                              expression: "search.channel_code",
                            },
                          },
                          _vm._l(
                            _vm.compFilterPaymentChannel,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.channel_code,
                                  value: item.channel_code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.original_transaction_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", clearable: "" },
                          model: {
                            value: _vm.search.original_transaction_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.search,
                                "original_transaction_id",
                                $$v
                              )
                            },
                            expression: "search.original_transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.mch_refund_order_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", clearable: "" },
                          model: {
                            value: _vm.search.mch_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "mch_order_id", $$v)
                            },
                            expression: "search.mch_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.refund_transaction_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", clearable: "" },
                          model: {
                            value: _vm.search.refund_transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "refund_transaction_id", $$v)
                            },
                            expression: "search.refund_transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("customerService.refund_type"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { filterable: "", clearable: "" },
                            model: {
                              value: _vm.search.refund_category,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "refund_category", $$v)
                              },
                              expression: "search.refund_category",
                            },
                          },
                          _vm._l(_vm.refundStatusMap, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.refund_status"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { filterable: "", clearable: "" },
                            model: {
                              value: _vm.search.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "status", $$v)
                              },
                              expression: "search.status",
                            },
                          },
                          _vm._l(_vm.refundTypeMap, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filter-item" }),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "mb-10 mr-12",
                  attrs: { slot: "reference", type: "info", plain: "" },
                  slot: "reference",
                },
                [
                  _c("svg-icon", {
                    attrs: { "class-name": "mr-10", "icon-class": "filter" },
                  }),
                  _vm._v(_vm._s(_vm.$t("components.filter"))),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "mb-10 download-btn",
              attrs: { plain: "", loading: _vm.downloading, type: "info" },
              on: { click: _vm.onClickDowmloadBtn },
            },
            [
              _c("svg-icon", { attrs: { "icon-class": "download" } }),
              _vm._v(" " + _vm._s(_vm.$t("components.download"))),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "total-container" }, [
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.total_count"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(_vm._s(_vm.summaryData.total_refund_count)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("customerService.full_refund_summary"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(_vm.summaryData.total_refund_amount)
                )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("customerService.return_fee_summary"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(
                    Math.abs(_vm.summaryData.total_fee_refunded)
                  )
                )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("customerService.total_refund_fee"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(
                    Math.abs(_vm.summaryData.total_refund_fee)
                  )
                )
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.original_transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.original_transaction_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.mch_refund_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.mch_order_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.refund_transaction_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.payment_method"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getPayinPaymentMethodMap(
                                scope.row.pay_product_type
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchant.payment_channel"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.refund_type"),
                  align: "center",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-wrap" },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "payin-status tag-custom",
                                attrs: {
                                  type: _vm.getRefundStatusMapType(
                                    scope.row.refund_category
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getRefundStatusMap(
                                        scope.row.refund_category
                                      )
                                    )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.original_transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("toDivideWithDot")(
                                  scope.row.original_transaction_amount
                                )
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_order_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.this_time_refund_amount
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refunded_transaction_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                Math.abs(scope.row.refund_transaction_fee)
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                Math.abs(scope.row.actual_receive_refund_amount)
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.refund_fee)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "160",
                  label: _vm.$t("customerService.refund_status"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "payin-status tag-custom",
                            attrs: {
                              type: _vm.getRefundTypeMapType(scope.row.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getRefundTypeMap(scope.row.status))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_create_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_return_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          { attrs: { placement: "top", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "text-align-center" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "operation-click-text-default",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickDetailTxt(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.detail"))
                                    ),
                                  ]
                                ),
                                scope.row.status === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          margin: "5px 0",
                                          border: "none",
                                          "font-size": "14px",
                                        },
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickRefundTxt(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("components.refund")) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  padding: "5px",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(" ••• ")]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("refund-details-modal", {
        ref: "refundDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
      _c("refund-modal", {
        ref: "refundModal",
        attrs: { "detail-id": _vm.detailId },
        on: { updateList: _vm.handleFilter },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }